import Q1 from "../../images/Icons/q1.svg";
import Q2 from "../../images/Icons/q2.svg";
import Q3 from "../../images/Icons/q3.svg";
import Q4 from "../../images/Icons/q4.svg";
import Q5 from "../../images/Icons/q5.svg";
import Q6 from "../../images/Icons/q6.svg";
import Q7 from "../../images/Icons/q7.svg";
import Q8 from "../../images/Icons/q8.svg";
import Q9 from "../../images/Icons/q9.svg";
import Q10 from "../../images/Icons/q10.svg";

const questions = [
  {
    id: 1,
    title: "",
    desc: "Jack is a poor farmer. He keeps <br> his <b> savings in a jar.</b>",
    answer: "Store of Value",
    icon: Q1,
    answerText:
      "Jack is saving his money, transferring his wealth to his future self. The money is functioning as a <b>store of value.</b>",
  },
  {
    id: 2,
    title: "",
    desc: "Jack goes to town. He uses his savings to <b>buy magic beans.</b>",
    answer: "Medium of Exchange",
    icon: Q2,
    answerText: "Jack is trading his money for magic beans. Without money, Jack would have had to trade something else for the items. But money is accepted by sellers because it can always be re-traded for something the seller wants. Money here is serving the purpose of a universal <b>medium of exchange.</b>",
  },
  {
    id: 3,
    title: "",
    desc: "Jack plants the beans and they grow into a huge beanstalk. He climbs the beanstalk and finds a <b>castle filled with treasures</b> (diamonds, rubies, and <b>gold coins</b>). What function are the coins serving?",
    answer: "Store of Value",
    icon: Q3,
    answerText:
      "The giant keeps his wealth in a vault. The gold coins are not being traded  (medium of exchange), nor are we using money for comparison (unit of account). Instead the gold is just sitting there, serving as a <b>store of value.</b>",
  },
  {
    id: 4,
    title: "",
    desc: "Jack calculates the value of the various treasures. <b>The gold coins are worth $100,000, the rubies $2 million, and the diamonds $10 million.</b> Realizing the diamonds are worth the most, Jack stuffs them in his pockets.",
    answer: "Unit of Account",
    icon: Q4,
    answerText:
      "Jack is using prices (in dollars) to compare the various items. So money here is functioning as <b>a unit of account.</b>",
  },
  {
    id: 5,
    title: "",
    desc: "Whoa, a giant appears! Jack scampers down the beanstalk. <b>He sells some diamonds and uses the money to buy an axe.</b> He chops down the beanstalk and the giant falls to his demise.",
    answer: "Medium of Exchange",
    icon: Q5,
    answerText:
      "Jack sells the diamonds for money and uses the money to buy an axe. Money is functioning as a <b>medium of exchange</b>. If Jack tried to trade the diamonds for an axe, the axe seller might not want the diamonds. Thanks to money, Jack can always sell the diamonds to someone who wants them and then use the money to buy a much-needed axe.",
  },
  {
    id: 6,
    title: "",
    desc: "Jack’s giant killing makes him famous and his farm prospers. How does he know? <b>He compares his farm’s profits from this year and realizes he’s made 10 times more money than any other year.</b>",
    answer: "Unit of Account",
    icon: Q6,
    answerText:
      "Jack is using dollars to compare his profits from different years. Money here is functioning as a <b>unit of account.</b>",
  },
  {
    id: 7,
    title: "",
    desc: "Jack uses the money he makes to <b>pay for all sorts of luxuries: a vanity wagon plate (“GNTSLYR”), fancy shoes to make him appear taller, and a personal trainer.</b>",
    answer: "Medium of Exchange",
    icon: Q7,
    answerText:
      "Jack is trading his money for several items. Without money, Jack would have had to trade something else for the items. But money is accepted by sellers because it can always be re-traded for something the seller wants. Money here is serving the purpose of a universal <b>medium of exchange.</b>",
  },
  {
    id: 8,
    title: "",
    desc: "His farm prospers even more. <b>Jack looks at his earnings from last year, and realizes he is by far the richest person in the realm.</b>",
    answer: "Unit of Account",
    icon: Q8,
    answerText:
      "Jack is using dollars to compare his earnings over time. Money here is functioning as <b>a unit of account,</b> and making the comparison possible.",
  },
  {
    id: 9,
    title: "",
    desc: "Jack is super rich, he can't live on his farm anymore. So he builds a large staircase and <b>buys the giant’s old castle in the clouds from the giant’s widow.</b>",
    answer: "Medium of Exchange",
    icon: Q9,
    answerText:
      "Jack is trading his money for the castle. Without money, Jack would have had to trade something else for the castle. But money is accepted by sellers because it can always be re-traded for something the seller wants. Money here is serving the purpose of a universal <b>medium of exchange.</b>",
  },
  {
    id: 10,
    title: "",
    desc: "<b>Jack fills the castle’s vault with money and other valuables</b>—more than even the giant had.",
    answer: "Store of Value",
    icon: Q10,
    answerText:
      "Like the giant before him, Jack is using the vault to keep money. The money is functioning as a <b>store of value.</b>",
  },
];

export default questions;
